import React from 'react';
import {
  Grid,
  Typography,
  TypographyList,
  TypographyListItem,
} from '@gogame/components';

export default ({ value, colDef, row }) => {
  const { placeholder } = colDef;

  return (
    <Grid
      direction={'column'}
      justifyContent={'center'}
      sx={{ height: '100%', display: 'flex' }}
    >
      {value?.length ? (
        <Grid sx={{ display: 'flex' }}>
          <TypographyList
            limit={1}
            divider={','}
            spacing={0.5}
            variant={'body2'}
            menuVariant={'body2'}
            unitsLabel={'Applications'}
            MenuProps={{
              anchorProps: {
                noWrap: true,
              },
            }}
          >
            {value.map((item, index) => {
              return (
                <TypographyListItem noWrap key={index} disableTooltip={true}>
                  {item.name}
                </TypographyListItem>
              );
            })}
          </TypographyList>
        </Grid>
      ) : (
        placeholder
      )}
      {row.excludeApplications?.length ? (
        row.excludeApplications?.length === 1 ? (
          <Grid sx={{ display: 'flex' }}>
            <Typography
              noWrap
              color={'textSecondary'}
              variant={'caption'}
            >{`${row.excludeApplications[0].name} excluded`}</Typography>
          </Grid>
        ) : (
          <Grid sx={{ display: 'flex' }}>
            <TypographyList
              limit={1}
              divider={','}
              spacing={0.5}
              variant={'body2'}
              menuVariant={'body2'}
              unitsLabel={'Applications excluded'}
              MenuProps={{
                anchorProps: {
                  noWrap: true,
                  color: 'textSecondary',
                  variant: 'caption',
                },
              }}
            >
              {row.excludeApplications.map((item, index) => {
                return (
                  <TypographyListItem noWrap key={index} disableTooltip={true}>
                    {item.name}
                  </TypographyListItem>
                );
              })}
            </TypographyList>
          </Grid>
        )
      ) : null}
      {row.onlyApplication ? (
        <Grid sx={{ display: 'flex' }}>
          <Typography noWrap color={'textSecondary'} variant={'caption'}>
            Never registered in the company's other applications
          </Typography>
        </Grid>
      ) : null}
    </Grid>
  );
};
